import type { SystemEmailSettings } from "@xop/dashboard-shared";

import { api } from "../../../lib/api.js";

/** The dashboard BFF's `/api/admin/system-emails` (→ crm-api, which sends the mail). */
export const systemEmailsApi = {
  load: () => api<SystemEmailSettings>("/api/admin/system-emails"),
  /** Replace the ONE list of people who receive every system email. Empty = nobody receives them. */
  save: (userIds: number[]) =>
    api<SystemEmailSettings>("/api/admin/system-emails", {
      method: "PUT",
      body: { user_ids: userIds },
    }),
};

export const SYSTEM_EMAILS_QUERY_KEY = ["admin", "system-emails"] as const;
